import { createContext } from 'react'

type SignOutTrigger = () => void

export const AuthorizationContext = createContext<SignOutTrigger | null>(null)
